import { zAttribute } from "src/types/ZAttribute";
import { z } from "zod";
import { zAttrLabelTreeData } from "./ZAttrLabelTreeData";

export const zAttrLabelsAttributes = z
  .object({ own: zAttribute.array(), external: zAttribute.array() })
  .optional();

export type ZAttrLabelsAttributes = z.infer<typeof zAttrLabelsAttributes>;

export const zAttrLabelsData = z.object({
  labels: zAttrLabelTreeData.array(),
  attributes: zAttrLabelsAttributes,
});

export type ZAttrLabelsData = z.infer<typeof zAttrLabelsData>;
